import React from 'react';

interface StickySectionProps {
  id: string;
  children: React.ReactNode;
  label?: string;
}

const StickySection: React.FC<StickySectionProps> = ({ id, children, label }) => {
  return (
    <>
      <section
        id={id}
        className="sticky-section"
        aria-label={label}
      >
        <div className="section-content">
          {children}
        </div>
      </section>
    </>
  );
};

export default StickySection;